import { Notification, NotificationProps } from '@bitrise/bitkit';

interface RetryNotificationProps extends NotificationProps {
  onRetry: () => void;
  retryLabel?: string;
}

const RetryNotification = ({
  children,
  onRetry,
  retryLabel = 'Retry',
  ...notificationProps
}: RetryNotificationProps): JSX.Element => (
  <Notification action={{ label: retryLabel, onClick: onRetry }} {...notificationProps}>
    {children}
  </Notification>
);

export default RetryNotification;
